import { useState, useMemo } from 'react'
import type { Settlement } from '../types/settlement.types'
import { mockSettlements } from '../data/mockSettlements'

export const useSettlements = () => {
    const [settlements] = useState<Settlement[]>(mockSettlements)
    const [searchText, setSearchText] = useState('')

    const filteredSettlements = useMemo(() => {
        if (!searchText) return settlements
        const lowerSearch = searchText.toLowerCase()
        return settlements.filter(s => 
            s.id.toLowerCase().includes(lowerSearch) ||
            s.merchant.toLowerCase().includes(lowerSearch)
        )
    }, [settlements, searchText])

    return {
        settlements: filteredSettlements,
        searchText,
        setSearchText
    }
}
